// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-module__loader--3vZtX","circular":"loader-module__circular--2-D3X","path":"loader-module__path--1IUzc"};